<div
  class="p-2 border-2 border-gray-100 hover:border-blue-100 flex justify-content-between"
  [class.bg-blue-50]="expandTasks"
  (click)="selectSupplier()"
>
  <div class="flex-1">
    <div class="flex justify-content-between align-items-center">
      <div class="flex align-items-center">
        <h3 class="m-0">{{ riskManagementSupplier.supplierName }}</h3>
      </div>

      <pill>
        <span *ngIf="riskManagementSupplier.assigneeName"
          >Assigned to
          <span class="bold-text">{{ riskManagementSupplier.assigneeName }}</span></span
        >
        <span *ngIf="!riskManagementSupplier.assigneeName">Unassigned</span>
      </pill>
    </div>
    <div *ngIf="riskManagementSupplier.tasks.length">
      <div class="flex flex-wrap gap-2 mt-2 mb-3">
        <span class="flex align-items-center">
          <pin-icon></pin-icon>
          <span class="ml-1"
            >{{ currentTask.customerName }}
            <span class="text-gray-600" *ngIf="currentTask.customerPriority">
              ({{ AMPriorityEnum[currentTask.customerPriority] }})
            </span>
          </span>
        </span>
        <span>•</span>
        <a target="_blank" href="/app/jobscreen/{{ currentTask.jobId }}">{{
          currentTask.jobNumber
        }}</a>
        <span>•</span>
        <span
          >{{ currentTask.taskStatus }}
          (Task
          {{ currentTask.currentTaskNumber }}
          of
          {{ currentTask.tasksInJob }})</span
        >
      </div>
      <div class="inline-flex gap-2 align-items-center p-1" (click)="expandTasks = !expandTasks">
        <span
          ><span class="bold-text">{{ riskManagementSupplier.jobsCount }} Jobs</span> ({{
            riskManagementSupplier.tasksCount
          }}
          Tasks)</span
        >
        <risk-pill *ngIf="riskManagementSupplier.riskCount"
          >{{ riskManagementSupplier.riskCount }} Major Risks</risk-pill
        >
        <button class="empty-button cursor-pointer">
          <i
            class="fa"
            [class.fa-chevron-up]="expandTasks"
            [class.fa-chevron-down]="!expandTasks"
          ></i>
        </button>
      </div>

      <div class="transition-container overflow-auto my-2" [class.expanded]="expandTasks">
        <div class="border-1 border-round-sm border-gray-200 bg-white">
          <risk-management-supplier-list-item-task
            *ngFor="let task of riskManagementSupplier.tasks; trackBy: trackByTaskId"
            [supplierTask]="task"
            (reviewStatusChange)="handleReviewStatusChange($event)"
          ></risk-management-supplier-list-item-task>
        </div>
      </div>
    </div>
  </div>

  <div class="align-content-center hover:bg-gray-100 cursor-pointer">
    <div class="p-2">
      <i class="fa fa-chevron-right"></i>
    </div>
  </div>
</div>
